import { render, staticRenderFns } from "./UserManagementLayout.vue?vue&type=template&id=dfea6cfe"
import script from "./UserManagementLayout.vue?vue&type=script&lang=ts"
export * from "./UserManagementLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports